"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const withParentDimensions_1 = require("../generic/withParentDimensions");
const common_styled_components_1 = require("../common-styled-components");
const routes_1 = require("../../util/routes");
const NavigationContext_1 = require("../../contexts/NavigationContext");
const ToolContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(5)};
  box-sizing: border-box;
  max-width: 100%;
  box-sizing: border-box;
  background-color: white;
`;
const IntroContainer = (0, styled_components_1.default)(common_styled_components_1.TextContent) `
  padding: ${theme_1.theme.spacing(4)};
`;
const BorderedFullWidthContainer = (0, styled_components_1.default)(common_styled_components_1.FullWidthContainer) `
  border-top: 1px solid ${theme_1.theme.colors.grey(4)};
`;
const ToolColumns = styled_components_1.default.div `
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: 320px 1fr;
  box-sizing: border-box;
`;
const SelectionsContainer = styled_components_1.default.div `
  width: 100%;
  border-${(p) => p.border}: 1px solid ${theme_1.theme.colors.grey(4)};
  padding: ${theme_1.theme.spacing(4)};
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(3)};
  box-sizing: border-box;
`;
const ResultsContainer = styled_components_1.default.section `
  padding: 0 ${theme_1.theme.spacing(4)};
  box-sizing: border-box;
  overflow-x: auto;
`;
const ToolLayout = (0, withParentDimensions_1.withParentDimensions)(({ parentDimensions: { width }, intro, selections, results, }) => {
    const isNarrowScreen = width < theme_1.breakpoints.tablet;
    return ((0, jsx_runtime_1.jsxs)(ToolContainer, { children: [(0, jsx_runtime_1.jsxs)(IntroContainer, { children: [(0, jsx_runtime_1.jsx)(NavigationContext_1.UpLinkWithHistory, { to: routes_1.routeNames.main, children: " All tools" }), process.env.NODE_ENV === "development" ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { style: { color: theme_1.theme.colors.red }, children: "Development version" })) : undefined, (0, jsx_runtime_1.jsx)(common_styled_components_1.Ingress, { children: intro })] }), (0, jsx_runtime_1.jsx)(BorderedFullWidthContainer, { children: isNarrowScreen ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SelectionsContainer, { border: "bottom", children: selections }), (0, jsx_runtime_1.jsx)(ResultsContainer, { children: results })] })) : ((0, jsx_runtime_1.jsxs)(ToolColumns, { children: [(0, jsx_runtime_1.jsx)(SelectionsContainer, { border: "right", children: selections }), (0, jsx_runtime_1.jsx)(ResultsContainer, { children: results })] })) })] }));
});
exports.default = ToolLayout;
